/// <amd-module name="Build/ArtifactsView/Components/ConsumedArtifactsComponent/ConsumedContainerResourcesCard" />
import * as React from "react";

import * as Resources from "Build/ArtifactsView/Resources";
import { IBuildLinkingService } from "Build/Client/Linking";
import { ConsumedArtifactDetails } from "Build/Client/Contracts/DataProvider";
import { NavConstants } from "Build/Common/Library/Constants";
import { ConsumedArtifactPropertyKeys, IConsumedArtifactsCardProps } from "Build/ArtifactsView/Components/ConsumedArtifactsComponent/ConsumedArtifactsResources"

import { Table, ITableColumn, TableColumnStyle, SimpleTableCell } from "VSSUI/Table";
import { Tooltip } from "VSSUI/TooltipEx";
import { Icon } from "VSSUI/Icon";
import { onClickFPS } from "VSS/Platform/FPS";
import { IHeaderCommandBarItem } from "VSSUI/HeaderCommandBar";
import { VssComponent, IVssComponentContext } from "VSS/Platform/Layout";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { Card } from "VSSUI/Card";
import { Button } from "VSSUI/Button";
import { getAssetLocation } from "VSS/Platform/Location";
import { ObservableArray, ObservableValue } from "VSS/Core/Observable";
import { copyToClipboard } from "VSSUI/Clipboard";

export class ConsumedContainerResourcesCard extends VssComponent<IConsumedArtifactsCardProps> {

    constructor(props: IConsumedArtifactsCardProps, context: IVssComponentContext) {
        super(props, context);
        const imageName = "https://" + this.containerImageUri;
        this._hasImageDetails(imageName).then(hasImageDetails => {
            if (hasImageDetails && hasImageDetails.hasOwnProperty("hasImageDetails")) {
                this.hasImageDetails = ((hasImageDetails["hasImageDetails"] as unknown) as { [key: string]: boolean })[imageName];
                this.setState({});
            }
        });
    }

    public render(): JSX.Element {
        if (!this.props.consumedSource)
        {
            return <React.Fragment/>;
        }

        return (
            <Card
                className="bolt-table-card" 
                headerIconProps={{render: this._renderIcon }}
                titleProps={{ text: this.props.consumedSource.alias + ' / ' + this.props.consumedSource.versionName }}
                headerCommandBarItems={this._getCommandBarItems()}
                contentProps={{ contentPadding: false }}>
                {this._jobsTable()}
            </Card>
        )
    }

    private _renderIcon = (): JSX.Element => {
        return (
            <div>
                <img
                    src={getAssetLocation(this.context.pageContext, "ms.vss-build-web/artifacts-view/icons/azure-container-repository.svg")}
                    alt={Resources.Container} />
            </div>
        );
    }

    private _getCommandBarItems(): IHeaderCommandBarItem[] {
        let commandBarItems: IHeaderCommandBarItem[] = [];
        if (this.hasImageDetails) {
            commandBarItems.push(
                {
                    important: true,
                    id: "viewDetails" + this.props.consumedSource.versionId,
                    text: Resources.ViewDetails,
                    onActivate: () => {
                        let linkingService = this.context.pageContext.getService<IBuildLinkingService>("IBuildLinkingService");
                        var url = linkingService.getBuildUrl(
                            this.props.buildId, 
                            NavConstants.artifacts, 
                            undefined, 
                            undefined,
                            {
                                [NavConstants.imageUri]: this.props.consumedSource.properties[ConsumedArtifactPropertyKeys.ContainerImageUri],
                                [NavConstants.alias]: this.props.consumedSource.alias,
                                [NavConstants.tag]: this.props.consumedSource.versionName
                            }
                        );
                        onClickFPS(this.context.pageContext, url, true);
                    }
                }
            )
        }

        return commandBarItems;
    }

    private _jobsTable(): JSX.Element {
        const itemProvider = new ObservableArray(this.props.consumedSource.consumedArtifacts);
        return <Table itemProvider={itemProvider} columns={this._jobsTableColumns} ariaLabel={Resources.ConsumedContainerTableText} />
    }

    private _getIcon = (): string => {
        return "Package";
    }

    private _renderNameCell = (rowIndex: number, columnIndex: number, tableColumn: ITableColumn<ConsumedArtifactDetails>): JSX.Element => {
        return (
            <SimpleTableCell columnIndex={columnIndex} tableColumn={tableColumn} key={"col-" + columnIndex} contentClassName="fontSizeM scroll-hidden">
                <Icon className="pipelines-icon-right-margin" iconName={this._getIcon()} />
                <div className="flex-row scroll-hidden">
                    <Tooltip overflowOnly={true} text={this.containerImageUri}>
                        <span className="text-ellipsis fontWeightSemiBold">{this.containerImageUri}</span>
                    </Tooltip>
                </div>
            </SimpleTableCell>
        );
    }

    private _renderCopyButton = (rowIndex: number, columnIndex: number, tableColumn: ITableColumn<ConsumedArtifactDetails>, tableItem: ConsumedArtifactDetails): JSX.Element => {
        return (
            <SimpleTableCell columnIndex={columnIndex} tableColumn={tableColumn} key={"col-" + columnIndex} contentClassName="fontSizeM scroll-hidden">
                <Button
                    className="bolt-table-cell-content-reveal justify-center"
                    subtle={true}
                    ariaLabel="Copy to Clipboard"
                    iconProps={{ iconName: 'Copy' }}
                    onClick={() => {copyToClipboard(this.containerImageUri);}}
                    tooltipProps={
                        {
                            text: Resources.CopyToClipboard
                        }
                    }
                />
            </SimpleTableCell>
        );
    }

    private _hasImageDetails(imageName: string): Promise<{ [key: string]: boolean } | undefined> {
        let additionalProperties = { imageNames: [imageName] };
        let contributionService = this.context.pageContext.getService<IVssContributionService>("IVssContributionService");
        return contributionService.getDataAsync<{ [key: string]: boolean }>("ms.vss-environments-web.has-image-details-data-provider", additionalProperties, true);
    }

    private readonly _jobsTableColumns: ITableColumn<ConsumedArtifactDetails>[] = [
        {
            id: Resources.ConsumedArtifactsImageColumn,
            width: -20,
            name: Resources.ConsumedArtifactsImageColumn,
            renderCell: this._renderNameCell,
            columnStyle: TableColumnStyle.Primary
        },
        {
            id: "copyButton",
            width: new ObservableValue(100),
            renderCell: this._renderCopyButton,
        }
    ];

    private hasImageDetails: boolean;
    private containerImageUri = this.props.consumedSource.properties[ConsumedArtifactPropertyKeys.ContainerImageUri];
}